define('models/composer/forms/Survey',[
    'lib/knockout',
    'lib/lodash4',
    'util/ObservableModel',
    'models/composer/forms/QuestionGroup'
], function (
    ko,
    _,
    ObservableModel,
    QuestionGroupModel
) {
    'use strict';

    var SurveyModel = ObservableModel.extend({
        defaults: {
            organizationId: '',
            type: 'survey',
            name: '',
            notes: '',
            version: 0,
            published: false,
            questionGroups: [{}], //Default to a single question group
            comments: ''
            //publishedVersions
            //totalPublishedVersions
        },
        modelProperties: {
            questionGroups: QuestionGroupModel
        }
    }, function surveyModel_init(model) {
        var self = this;

        self.modelId = _.uniqueId("survey");
        var hasFakeId = false;
        if (!self.id) {
            self.id = self.modelId;
            hasFakeId = true;
        }

        model = model || {};
        if(model.publishedVersions) {
            self.publishedVersions = model.publishedVersions.entities;
            self.totalPublishedVersions = model.publishedVersions.total;
        } else {
            self.publishedVersions = [];
        }

        self.addQuestionGroup = function (data, index) {
            var newQuestionGroupModel = new QuestionGroupModel(data);
            self.questionGroups.splice(index, 0, newQuestionGroupModel);
            return newQuestionGroupModel;
        };

        self.questionMap = ko.computed(function () {
            return _.reduce(self.questionGroups(), function (accumulator, questionGroup, index) {
                questionGroup.index(index);
                return _.assign(accumulator, questionGroup.questionMap());
            }, {});
        });

        self.name = self.name.extend({trimmed: null}); //trim whitespace off the name

        // Add Knockout-Validation functionality.
        self.name.extend({ required: true, 
                            maxLength: {
                                params: 250,
                                message: "composer.evaluations.editor.evaluation.nameTooLong"
                            }    
                        });
        ko.validation.group(self, {
            deep: true,
            live: true //Properly validate observable arrays, see https://github.com/Knockout-Contrib/Knockout-Validation/pull/223
        });

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'evaluation': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.unwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            var typeName = self.type();
            var ignore = [
                "errors",
                "isAnyMessageShown",
                "isValid",
                "modelId",
                "unwrap",
                "questionGroups",
                "questionMap",
                "addQuestionGroup",
                "publishedVersions",
                "totalPublishedVersions"
            ];
            if (options.ignoreFakeIds && hasFakeId) {
                ignore.push('id');
            }
            var passToKids = false;
            if (toIgnore instanceof Array) { // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else { // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
                passToKids = true;
            }
            var data = ObservableModel.unwrap(self, ignore);
            data.questionGroups = _.map(self.questionGroups(), function (submodel) {
                return submodel.unwrap(passToKids ? toIgnore : undefined, options);
            });
            return data;
        };
    });

    return SurveyModel;
});

